export default __webpack_public_path__ + "static/media/1978.a93344fa.png";